module.exports = __webpack_public_path__ + "img/fixated-multipoint-lock.4d2a394.svg";